import React from "react";

import { Form } from "react-bootstrap";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import {
  StyledDropdown,
  StyledDropdownToggle,
  StyledFontAwesomeIcon,
  StyledDropdownMenu,
  StyledDropdownItem,
} from "../styled";

export const BasicInput = ({
  id,
  label,
  type = "text",
  onChange,
  value,
  disabled = false,
  placeholder = "",
  readOnly = false,
  descri = "",
  minDate = new Date().toISOString().slice(0, 10),
}: any) => {
  return (
    <>
      {label && (
        <Form.Label style={{ width: "40%" }} htmlFor={id}>
          {label}
        </Form.Label>
      )}
      <Form.Control
        readOnly={readOnly}
        disabled={disabled}
        type={type}
        id={id}
        onChange={(e: any) => onChange(e.target.value)}
        value={value}
        min={minDate}
        placeholder={placeholder}
      />
      {descri && <Form.Text muted>{descri}</Form.Text>}
    </>
  );
};

export const BasicSelect = ({ options, onChange, title = "-", width = "100%" }: any) => {
  return (
    <StyledDropdown width={width}>
      <StyledDropdownToggle>
        {title}
        {<StyledFontAwesomeIcon icon={faChevronDown} />}
      </StyledDropdownToggle>

      <StyledDropdownMenu>
        {options.map((option: any) => (
          <StyledDropdownItem
            onClick={() => {
              onChange(option);
            }}>
            {option.label}
          </StyledDropdownItem>
        ))}
      </StyledDropdownMenu>
    </StyledDropdown>
  );
};
